// extracted by mini-css-extract-plugin
export default {"blockContainer":"blockContainer-S4z8Pi9SQIQ7iGR8LXTW","shadow":"shadow-_vDBx1WsL53mX5Q2B1yI"};